import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import styles from './InstagramItems.css';

class InstagramItems extends Component {
  static propTypes = {
    instagrams: PropTypes.arrayOf(PropTypes.object),
  };

  render() {
    const { instagrams } = this.props;
    const settings = {
      dots: true,
      arrows: false,
      center: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
      ],
    }
    const slides = instagrams.map((instagram, idx) =>
      <a href={instagram.link} target="_blank" className={styles.link} key={instagram.createdAt}>
        <div className={classnames(styles.content, { [styles.rowPos0]: idx % 4 === 0 })}>
          <div className={styles.contentImg} style={{ backgroundImage: `url(${instagram.picUrl}` }} />
        </div>
      </a >
    );

    return (
      <div className={styles.contentCarousel}>
        <Slider ref="slider" {...settings}>
          {slides}
        </Slider>
      </div>
    );
  }
}

export default InstagramItems;



// WEBPACK FOOTER //
// ./src/components/instagram-items/InstagramItems.js